var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-blog" }, [
    _c("h2", [_vm._v("Blog")]),
    _vm._v(" "),
    !_vm.isMobile
      ? _c(
          "div",
          { staticClass: "home-blog__entries home-blog__entries--desktop" },
          [
            _c("div", { staticClass: "home-blog__entry" }, [
              _c(
                "a",
                {
                  staticClass: "d-block swiper-inner-container",
                  attrs: { href: _vm.options[9], target: "_blank" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "home-blog__img-btn-wrapper" },
                    [
                      _c("lazy-img", {
                        attrs: {
                          "picture-class": "",
                          "image-url": _vm.options[12],
                          alt: _vm.options[0],
                          title: _vm.options[0]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "home-blog__entry-button" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "home-blog__entry-button-txt" },
                        [_vm._v(_vm._s(_vm.options[6]))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "home-blog__entry-content" }, [
                    _c(
                      "div",
                      { staticClass: "home-blog__entry-content-headline" },
                      [_vm._v(_vm._s(_vm.options[0]))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "home-blog__entry-content-txt" }, [
                      _vm._v(_vm._s(_vm.options[3]))
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home-blog__entry" }, [
              _c(
                "a",
                {
                  staticClass: "d-block swiper-inner-container",
                  attrs: { href: _vm.options[10], target: "_blank" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "home-blog__img-btn-wrapper" },
                    [
                      _c("lazy-img", {
                        attrs: {
                          "picture-class": "",
                          "image-url": _vm.options[13],
                          alt: _vm.options[1],
                          title: _vm.options[1]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "home-blog__entry-button" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "home-blog__entry-button-txt" },
                        [_vm._v(_vm._s(_vm.options[7]))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "home-blog__entry-content" }, [
                    _c(
                      "div",
                      { staticClass: "home-blog__entry-content-headline" },
                      [_vm._v(_vm._s(_vm.options[1]))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "home-blog__entry-content-txt" }, [
                      _vm._v(_vm._s(_vm.options[4]))
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "home-blog__entry" }, [
              _c(
                "a",
                {
                  staticClass: "d-block swiper-inner-container",
                  attrs: { href: _vm.options[11], target: "_blank" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "home-blog__img-btn-wrapper" },
                    [
                      _c("lazy-img", {
                        attrs: {
                          "picture-class": "",
                          "image-url": _vm.options[14],
                          alt: _vm.options[2],
                          title: _vm.options[2]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "home-blog__entry-button" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "home-blog__entry-button-txt" },
                        [_vm._v(_vm._s(_vm.options[8]))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "home-blog__entry-content" }, [
                    _c(
                      "div",
                      { staticClass: "home-blog__entry-content-headline" },
                      [_vm._v(_vm._s(_vm.options[2]))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "home-blog__entry-content-txt" }, [
                      _vm._v(_vm._s(_vm.options[5]))
                    ])
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isMobile
      ? _c(
          "div",
          { staticClass: "home-blog__entries home-blog__entries--mobil" },
          [
            _c("div", { ref: "swiper", staticClass: "swiper-container" }, [
              _c("div", { staticClass: "swiper-wrapper" }, [
                _c("div", { staticClass: "swiper-slide" }, [
                  _c(
                    "a",
                    {
                      staticClass: "d-block swiper-inner-container",
                      attrs: { href: _vm.options[9], target: "_blank" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "home-blog__img-btn-wrapper" },
                        [
                          _c("lazy-img", {
                            attrs: {
                              "picture-class": "",
                              "image-url": _vm.options[12],
                              alt: _vm.options[0],
                              title: _vm.options[0]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "home-blog__entry-button" },
                            [
                              _c(
                                "div",
                                { staticClass: "home-blog__entry-button-txt" },
                                [_vm._v(_vm._s(_vm.options[6]))]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "home-blog__entry-content" }, [
                        _c(
                          "div",
                          { staticClass: "home-blog__entry-content-headline" },
                          [_vm._v(_vm._s(_vm.options[0]))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "home-blog__entry-content-txt" },
                          [_vm._v(_vm._s(_vm.options[3]))]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slide" }, [
                  _c(
                    "a",
                    {
                      staticClass: "d-block swiper-inner-container",
                      attrs: { href: _vm.options[10], target: "_blank" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "home-blog__img-btn-wrapper" },
                        [
                          _c("lazy-img", {
                            attrs: {
                              "picture-class": "",
                              "image-url": _vm.options[13],
                              alt: _vm.options[1],
                              title: _vm.options[1]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "home-blog__entry-button" },
                            [
                              _c(
                                "div",
                                { staticClass: "home-blog__entry-button-txt" },
                                [_vm._v(_vm._s(_vm.options[7]))]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "home-blog__entry-content" }, [
                        _c(
                          "div",
                          { staticClass: "home-blog__entry-content-headline" },
                          [_vm._v(_vm._s(_vm.options[1]))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "home-blog__entry-content-txt" },
                          [_vm._v(_vm._s(_vm.options[4]))]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slide" }, [
                  _c(
                    "a",
                    {
                      staticClass: "d-block swiper-inner-container",
                      attrs: { href: _vm.options[11], target: "_blank" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "home-blog__img-btn-wrapper" },
                        [
                          _c("lazy-img", {
                            attrs: {
                              "picture-class": "",
                              "image-url": _vm.options[14],
                              alt: _vm.options[2],
                              title: _vm.options[2]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "home-blog__entry-button" },
                            [
                              _c(
                                "div",
                                { staticClass: "home-blog__entry-button-txt" },
                                [_vm._v(_vm._s(_vm.options[8]))]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "home-blog__entry-content" }, [
                        _c(
                          "div",
                          { staticClass: "home-blog__entry-content-headline" },
                          [_vm._v(_vm._s(_vm.options[2]))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "home-blog__entry-content-txt" },
                          [_vm._v(_vm._s(_vm.options[5]))]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-blog__prev" }, [
      _c("i", {
        staticClass: "icon-left",
        staticStyle: { "font-size": "20px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-blog__next" }, [
      _c("i", {
        staticClass: "icon-right",
        staticStyle: { "font-size": "20px" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }